import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/brand";

export default function Register() {
  const [form, setForm] = useState({
    full_name: "", email: "", password: "",
    brokerage_name: "", license_number: "",
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const upd = (k, v) => setForm({ ...form, [k]: v });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to OfferForge");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-8" data-testid="register-page">
      <div className="w-full max-w-lg">
        <div className="bg-navy rounded-sm p-6 mb-6 inline-block">
          <img src={LOGO_URL} alt="Moaglee" className="max-h-20 w-auto" />
        </div>

        <div className="grid-panel p-8">
          <div className="kicker mb-2">Create Account</div>
          <h2 className="text-3xl font-display mb-6">Your broker command center</h2>

          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            {[
              { key: "full_name", label: "Full Name", type: "text", req: true, placeholder: "Jane Broker" },
              { key: "email", label: "Business Email", type: "email", req: true, placeholder: "you@brokerage.com" },
              { key: "password", label: "Password", type: "password", req: true, placeholder: "min 6 characters" },
              { key: "brokerage_name", label: "Brokerage", type: "text", placeholder: "e.g., Cushman & Wakefield" },
              { key: "license_number", label: "License Number", type: "text", placeholder: "Optional" },
            ].map((f) => (
              <div key={f.key}>
                <label className="block text-xs uppercase tracking-widest text-slate-600 mb-1.5">{f.label}</label>
                <input
                  type={f.type} required={f.req} placeholder={f.placeholder}
                  value={form[f.key]} onChange={(e) => upd(f.key, e.target.value)}
                  data-testid={`register-${f.key}`}
                  className="w-full bg-white border border-border px-3 py-2.5 text-sm rounded-sm focus:outline-none focus:ring-2 focus:ring-brass"
                />
              </div>
            ))}

            <button type="submit" disabled={loading} data-testid="register-submit"
              className="btn-brass w-full justify-center py-3 mt-2 disabled:opacity-60">
              {loading ? "Creating…" : "Create Account"}
            </button>
          </form>

          <div className="mt-6 text-sm text-slate-600">
            Already have an account?{" "}
            <Link to="/login" className="link-brass font-medium" data-testid="link-to-login">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
